function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserServiceInternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 192V0h192v192z",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa726",
    d: "M95.897 89.397c-18.199 0-32.948-14.75-32.948-32.949 0-18.198 14.75-32.948 32.948-32.948 18.199 0 32.949 14.75 32.949 32.948 0 18.2-14.75 32.949-32.949 32.949",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "#b5c7cd",
      fillOpacity: 1,
      strokeWidth: 1.64743,
      strokeMiterlimit: 10
    },
    d: "M95.076 102.576c-1.487 0-2.946.04-4.377.115v.055c-43.764 2.779-60.494 40.065-60.494 40.065L30 168.473h79.871v-64.485a75.734 75.734 0 0 0-9.598-1.242v-.055a82.579 82.579 0 0 0-4.377-.115c-.138 0-.272.005-.41.006-.137 0-.272-.006-.41-.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#accddc",
      fillOpacity: 1,
      strokeWidth: 0.638199
    },
    d: "M32.694 13.818h-6.063V7.755Z",
    transform: "matrix(3.03334 0 0 3.03334 74.558 81.855)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.5,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      fillOpacity: 1,
      stroke: "#b8b8b8",
      strokeWidth: 1.5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M40 45H8V3h22l10 10z",
    transform: "translate(100.167 99.862) scale(1.83908)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8b8b8",
      fillOpacity: 1,
      strokeWidth: 1.5,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "M40 13H30V3Z",
    transform: "translate(100.167 99.862) scale(1.83908)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.9 31.4V13.212h18.188V31.4z",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.105748,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    transform: "matrix(3.03334 0 0 3.03334 74.558 81.855)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.033 29.71V13.945h15.763V29.71Z",
    style: {
      mixBlendMode: "normal",
      fill: "none",
      strokeWidth: 0.509257,
      strokeMiterlimit: 10
    },
    transform: "matrix(3.03334 0 0 3.03334 74.558 81.855)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.961 48.169c.358-2.51.717-5.017.717-7.884 0-2.866-.359-5.375-.717-7.883l16.125-11.467c1.433-1.075 2.15-3.225 1.075-5.016l-15.767-26.517c-1.075-1.792-2.866-2.508-4.658-1.433L97.82-3.791c-4.3-3.224-8.6-5.732-13.616-7.882l-1.792-19.708c-.358-1.792-1.792-3.225-3.583-3.225H48.011c-1.792 0-3.583 1.433-3.583 3.225l-1.792 19.708C37.62-9.523 32.961-7.015 29.02-3.79l-17.917-8.241c-1.79-.717-3.94 0-4.658 1.433L-8.964 15.919c-1.075 1.79-.358 3.94 1.075 5.016L8.236 32.402c-.358 2.508-.717 5.017-.717 7.883 0 2.867.36 5.375.717 7.884L-8.606 59.635c-1.433 1.075-2.15 3.225-1.075 5.017L5.727 91.169c1.075 1.79 2.867 2.508 4.66 1.433l17.915-8.242c4.3 3.225 8.6 5.734 13.617 7.884l1.792 19.708c.358 1.792 1.792 3.225 3.583 3.225h30.817c1.792 0 3.583-1.433 3.583-3.225l1.792-19.708c5.017-2.15 9.675-4.66 13.617-7.884l17.916 8.242c1.792.717 3.942 0 4.66-1.433l15.407-26.517c1.075-1.792.358-3.942-1.075-5.017zm-55.9 27.95c-19.708 0-35.833-16.125-35.833-35.833 0-19.71 16.125-35.834 35.833-35.834s35.833 16.125 35.833 35.834c0 19.708-16.125 35.833-35.833 35.833z",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "#677b84",
      fillOpacity: 1,
      strokeMiterlimit: 10
    },
    fill: "#607d8b",
    transform: "matrix(.26848 0 0 .26848 127.369 137.33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.061-2.715c-23.65 0-43 19.35-43 43s19.35 43 43 43 43-19.35 43-43-19.35-43-43-43zm0 60.917c-10.033 0-17.917-7.883-17.917-17.917 0-10.033 7.884-17.916 17.917-17.916 10.033 0 17.917 7.883 17.917 17.916 0 10.034-7.884 17.917-17.917 17.917z",
    fill: "#455a64",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      strokeMiterlimit: 10
    },
    transform: "matrix(.26848 0 0 .26848 127.369 137.33)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserServiceInternal);
export default __webpack_public_path__ + "static/media/userServiceInternal.df0277776e96532daffbaacdbd46aa68.svg";
export { ForwardRef as ReactComponent };